import * as React from 'react';
import Dialog from "diy/custom-components/dialog/Dialog";
import l10n from 'diy/util/l10n';

export interface GuidanceDialogProps {
    onDismiss?: () => void;
}

interface GuidanceDialogState {

}

export class GuidanceDialog extends React.Component<GuidanceDialogProps, GuidanceDialogState> {
    render() {
        let dialogWidth = 540;
        let iframeStyle = {
            border: 0,
            height: 447,
            width: dialogWidth,
            display: 'block'
        };
        let contentStyle = {
            transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
        };

        return (
            <Dialog
                width={dialogWidth}
                autoDetectWindowHeight={false}
                contentStyle={contentStyle}
                primaryButtonConfig={{
                    label: l10n('section.guidanceDialog.dismissLabel'),
                    callback: () => this.onDismiss()
                }}
            >
                <iframe style={iframeStyle} src="/app/help/section-guidance" />
            </Dialog>
        );
    }

    private onDismiss = () => {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/GuidanceDialog.tsx
 **/